<template>
  <div>
    <el-form
      :inline="true"
      class="demo-form-inline"
      size="mini"
      label-width="80px"
    >
      <el-form-item label="">
        <el-input
          ref="headerSearchInput"
          v-model="fullText"
          placeholder="Full Text Search"
          :clearable="true"
          size="medium"
          @keyup.enter.native="change()"
        >
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="search.sector"
          clearable placeholder="Sector">
          <el-option
            v-for="(value,index) in sectorList"
            :key="index"
            :label="value.itemName"
            :value="value.orderNum"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="search.status"
          clearable placeholder="Status">
          <el-option
            v-for="(value,index) in statusList"
            :key="index"
            :label="value.itemName"
            :value="value.orderNum"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="search.area"
          clearable placeholder="Area">
          <el-option
            v-for="(value,index) in areaList"
            :key="index"
            :label="value.label"
            :value="value.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="search.stage"
          clearable placeholder="Stage">
          <el-option
            v-for="(value,index) in stageList"
            :key="index"
            :label="value.itemName"
            :value="value.orderNum"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="search.revenue"
          clearable placeholder="Revenue">
          <el-option
            v-for="(value,index) in revenueList"
            :key="index"
            :label="value.itemName"
            :value="value.orderNum"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label-width="180px">
        <el-input v-model="search.name" clearable placeholder="English or Pinyin Name"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="search.keywords" clearable placeholder="keywords"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-date-picker
          v-model="customTime"
          size="mini"
          type="daterange"
          align="right"
          unlink-panels
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          range-separator="~"
          start-placeholder="startTime"
          end-placeholder="endTime"
          :picker-options="pickerOptions">
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="small" icon="el-icon-search" @click="change()"></el-button>
      </el-form-item>

      <el-form-item v-if="canCreate">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="createPage"></el-button>
      </el-form-item>

      <!--      <div class="nav-btn" v-if="canCreate">-->
      <!--      </div>-->

    </el-form>
    <div>
      <el-row :gutter="15">
        <el-col :span="6" :xs="24" :sm="12" :md="6" :lg="5" :xl="5" v-for="(item,index) in tableData.rows" :key="index">
          <div @click="item.documentId ? getDocumentInfo(item.documentId) : getDocumentInfo(item.id)">
            <!-- <el-card class="box-card"  shadow="hover" style="height: 200px;">
              <div class="box-crad__header">
                <p>{{item.entryDate}}</p>
                <p>{{item.sourcedBy}}</p>
              </div>
              <div style="padding:30px 0;">
                <p class="title">{{item.name}}</p>
                <p style="text-align: center;">{{getObjectValues(sectorList, item.sector)}}</p>
              </div>
              <div class="box-crad__footer">
                <p>{{getObjectValues(statusList, item.status)}}</p>
              </div>
            </el-card> -->
            <el-card class="box-card" shadow="hover" style="height: 200px;">
              <div class="box-crad__header">
                <p class="box-card_text">{{ formatMtime(item.mtime) }}</p>
                <p class="box-card_text">{{ getObjectValues(statusList, item.status) }}</p>
              </div>
              <div style="padding:20px 0;">
                <p class="box-card_text" style="font-size: 18px;">{{ item.name }}</p>
                <p class="box-card_text">{{ item.otherName || "-" }}</p>
                <p class="box-card_text">{{ getObjectValues(sectorList, item.sector) }}</p>
              </div>
              <div class="box-card__footer">
                <p class="box-card__footer_text">
                  <div v-if="Array.isArray(item.keywords)">
                    <el-tag effect="plain" size="mini" type="success" v-for="content in item.keywords"
                            :key="content.id">
                      {{ content.keyword.length > 20 ? content.keyword.substring(0, 19) + '...' : content.keyword }}
                    </el-tag>
                  </div>
                  <div v-else>
                    <el-tag v-if="item.keywords && item.keywords.length>0" effect="plain" size="mini" type="success">
                      {{ item.keywords }}
                    </el-tag>
                  </div>
                </p>
              </div>
            </el-card>
          </div>
        </el-col>
      </el-row>
      <div class="block" style="text-align: right;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="tableData.pagination.pageNo"
          :page-sizes="[15, 20, 50,100]"
          :page-size="tableData.pagination.pageSize"
          background
          layout="total, sizes, prev, pager, next"
          :total="tableData.pagination.totalSize">
        </el-pagination>
      </div>
    </div>
    <el-dialog title="info" top="5vh" :visible.sync="dialogTableVisible">
      <div class="demo-drawer__content">
        <div style="text-align: right;" v-if="canEdit">
          <el-button type="primary" size="small" icon="el-icon-edit" @click="editPage(form.documentId)"></el-button>
        </div>
        <div class="info-wapper">
          <table class="table-custom">
            <tr v-if="getfieldList('entry_date')?true:false">
              <th width="200">Entry Date</th>
              <td>{{ form.entryDate }}</td>
            </tr>
            <tr v-if="getfieldList('update_date')?true:false">
              <th>Update Date</th>
              <td>{{ formatMtime(form.mtime) }}</td>
            </tr>
            <tr v-if="getfieldList('name')?true:false">
              <th>English or Pinyin Name</th>
              <td>{{ form.name }}</td>
            </tr>
            <tr v-if="getfieldList('other_name')?true:false">
              <th>Chinese Name</th>
              <td>{{ form.otherName }}</td>
            </tr>
            <tr v-if="getfieldList('website')?true:false">
              <th>Website</th>
              <td>{{ form.website }}</td>
            </tr>
            <tr v-if="getfieldList('type')?true:false">
              <th>Type</th>
              <td>{{ form.type }}</td>
            </tr>
            <tr v-if="getfieldList('country')?true:false">
              <th>Country</th>
              <td>{{ form.country }}</td>
            </tr>
            <tr v-if="getfieldList('sector')?true:false">
              <th>Sector</th>
              <td>{{ form.sector }}</td>
            </tr>
            <tr v-if="getfieldList('product_stage')?true:false">
              <th>Product Stage</th>
              <td>{{ form.productStage }}</td>
            </tr>

            <tr v-if="getfieldList('revenue')?true:false">
              <th>Revenue Stage</th>
              <td>{{ form.revenue }}</td>
            </tr>
            <tr v-if="getfieldList('stage')?true:false">
              <th>Financing Stage</th>
              <td>{{ form.stage }}</td>
            </tr>
            <tr v-if="getfieldList('capital_raise')?true:false">
              <th>Capital Raise</th>
              <td>{{ form.capitalRaise }}</td>
            </tr>
            <tr v-if="getfieldList('keywords')?true:false">
              <th>Keywords</th>
              <td>{{ form.keywords }}</td>
            </tr>
            <tr v-if="getfieldList('company_description')?true:false">
              <th>Company Description</th>
              <td>{{ form.companyDescription }}</td>
            </tr>
            <tr v-if="getfieldList('technology_product')?true:false">
              <th>Technology & Product</th>
              <td>{{ form.technologyProduct }}</td>
            </tr>
            <tr v-if="getfieldList('market')?true:false">
              <th>Market</th>
              <td>{{ form.market }}</td>
            </tr>
            <tr v-if="getfieldList('competition')?true:false">
              <th>Competition</th>
              <td>{{ form.competition }}</td>
            </tr>
            <tr v-if="getfieldList('biz_model')?true:false">
              <th>Biz Model</th>
              <td>{{ form.bizModel }}</td>
            </tr>
            <tr v-if="getfieldList('team')?true:false">
              <th>Team</th>
              <td>{{ form.team }}</td>
            </tr>
            <tr v-if="getfieldList('financials')?true:false">
              <th>Financials</th>
              <td>{{ form.financials }}</td>
            </tr>

            <tr
              v-if="getfieldList('contact_person_name') || getfieldList('contact_person_role') || getfieldList('contact_person_mail') || getfieldList('contact_person_phone_num')">
              <th>Contact Person</th>
              <td>
                <div v-for="(contactPerson, index) in form.contactPersonList">
                  <p v-if="getfieldList('contact_person_name')?true:false"><span><svg-icon icon-class="username"
                                                                                           className="content"/> </span>{{
                      (index + 1) + '：' + contactPerson.contactPersonName
                    }}
                  </p>
                  <p v-if="getfieldList('contact_person_role')?true:false"><span><svg-icon icon-class="role"
                                                                                           className="content"/> </span>{{
                      (index + 1) + '：' + contactPerson.contactPersonRole
                    }}
                  </p>
                  <p v-if="getfieldList('contact_person_mail')?true:false"><span><svg-icon icon-class="email"
                                                                                           className="content"/> </span>{{
                      (index + 1) + '：' + contactPerson.contactPersonMail
                    }}
                  </p>
                  <p v-if="getfieldList('contact_person_phone_num')?true:false"><span><svg-icon icon-class="phone"
                                                                                                className="content"/> </span>{{
                      (index + 1) + '：' + contactPerson.contactPersonPhoneNum
                    }}
                  </p>
                </div>
              </td>
            </tr>
            <tr v-if="getfieldList('status')?true:false">
              <th>Status</th>
              <td>{{ form.status }}</td>
            </tr>
            <tr
              v-if="(getfieldList('cm_research')?true:false) && (getfieldList('status')?true:false) && form.status==60">
              <th>CM Research</th>
              <td>{{ form.cmResearchVal }}</td>
            </tr>
            <tr v-if="getfieldList('cm_comments')?true:false">
              <th>CM Comments</th>
              <td>{{ form.cmComments }}</td>
            </tr>

            <tr v-if="getfieldList('nda')?true:false">
              <th>NDA</th>
              <td>{{ form.nda == 1 ? 'Yes' : 'No' }}</td>
            </tr>
            <tr v-if="getfieldList('nda_file')?true:false">
              <th>NDA File</th>
              <td>
                <div v-for="(item,index) in form.ndaFileList" :key="index">
                  <svg-icon :icon-class="item.fileName" :suffix="true" className="file"></svg-icon>
                  <a v-if="item.fileName.indexOf('.xlsx')==-1" target="_blank"
                     :title="'创建时间：' + item.ctime+' '+getFileStatusText(item.taskStatus)"
                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false">{{
                      item.fileName
                    }}</a>
                  <a v-if="item.fileName.indexOf('.xlsx')>=0" target="_blank"
                     :href="'/#/excelpreview?url='+downFile+item.filePath">{{ item.fileName }}</a>
                  <a target="_blank" v-if="canDownload"
                     :href="canDownload && item.status == 30 ? downFile + item.filePath : false"
                     :download="item.fileName"><i class="el-icon-download"></i></a>
                </div>
              </td>
            </tr>
            <tr v-if="getfieldList('non_confidential_presentation_file')?true:false">
              <!-- <th>Non-confidential presentation File</th> -->
              <!-- <th><span><i class="el-icon-folder-opened" style="font-size:25px;"></i></span></th> -->
              <th>
                <svg-icon icon-class="folder" className="title"></svg-icon>
              </th>
              <td>
                <div v-for="(item,index) in form.nonConfidentialPresentation" :key="index">
                  <svg-icon :icon-class="item.fileName" :suffix="true" className="file"></svg-icon>
                  <!-- <a target="_blank" :href="item.status == 30 ? '/display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false" >{{item.fileName}}</a> -->
                  <a v-if="item.fileName.indexOf('.xlsx')==-1" target="_blank"
                     :title="'创建时间：' + item.ctime+' '+getFileStatusText(item.taskStatus)"
                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false">{{
                      item.fileName
                    }}</a>
                  <a v-if="item.fileName.indexOf('.xlsx')>=0" target="_blank"
                     :href="'/#/excelpreview?url='+downFile+item.filePath">{{ item.fileName }}</a>
                  <a target="_blank" :href="item.status == 30 ? downFile + item.filePath : false"
                     :download="item.fileName"><i class="el-icon-download"></i></a>
                </div>
              </td>
            </tr>
            <tr v-if="getfieldList('source')?true:false">
              <th>Source</th>
              <td>{{ form.source }}</td>
            </tr>
            <tr v-if="getfieldList('referred_by')?true:false">
              <th>Referred By</th>
              <td>{{ form.refferedBy }}</td>
            </tr>
            <tr v-if="getfieldList('sourced_by')?true:false">
              <th>Deal Team</th>
              <td>{{ form.sourcedBy }}</td>
            </tr>
            <!-- <tr v-if="getfieldList('deal_team')?true:false"><th>Deal Team</th><td>{{form.dealTeam}}</td></tr> -->
            <tr v-if="getfieldList('technology_product(confidential)')?true:false">
              <th><span>Technology & Product <svg-icon icon-class="lock" className="content"/></span></th>
              <td>{{ form.innerTechnologyProduct }}</td>
            </tr>
            <tr v-if="getfieldList('customer_traction(confidential)')?true:false">
              <th><span>Customer Traction <svg-icon icon-class="lock" className="content"/></span></th>
              <td>{{ form.customerTraction }}</td>
            </tr>
            <tr v-if="getfieldList('cm_comments(confidential)')?true:false">
              <th><span>CM Comments <svg-icon icon-class="lock" className="content"/></span></th>
              <td>{{ form.innerCMcomments }}</td>
            </tr>
            <tr v-if="getfieldList('activity_date') || getfieldList('activity_note')">
              <th>Activity</th>
              <td>
                <div v-for="(activityInfo, index) in form.activityInfoList">
                  <!-- <p  v-if="getfieldList('activity_date')?true:false">{{'ActivityDate_'+(index+1)+'：'+activityInfo.activityDate}}</p>
                  <p  v-if="getfieldList('activity_note')?true:false">{{'ActivityNote_'+(index+1)+'：'+activityInfo.activityNote}}</p> -->
                  <p v-if="getfieldList('activity_date')?true:false"><span><svg-icon icon-class="date"
                                                                                     className="content"/> </span>{{
                      (index + 1) + '：' + activityInfo.activityDate
                    }}
                  </p>
                  <p v-if="getfieldList('activity_note')?true:false"><span><svg-icon icon-class="note"
                                                                                     className="content"/> </span>{{
                      (index + 1) + '：' + activityInfo.activityNote
                    }}
                  </p>
                </div>
              </td>
            </tr>

            <tr v-if="getfieldList('enter_into_dd')?true:false">
              <th>Enter Into DD</th>
              <td>{{ form.enterIntoDd == 1 ? 'Yes' : 'No' }}</td>
            </tr>
            <tr v-if="getfieldList('term_sheet')?true:false">
              <th>Term-sheet</th>
              <td>{{ form.termSheet == 1 ? 'Yes' : 'No' }}</td>
            </tr>
            <tr v-if="getfieldList('term_sheet_comments')?true:false">
              <th>TS Comments</th>
              <td>{{ form.termSheetComments }}</td>
            </tr>
            <tr v-if="getfieldList('term_sheet_file')?true:false">
              <th>Term-sheet File</th>
              <td>
                <div v-for="(item,index) in form.termSheetFileList" :key="index">
                  <svg-icon :icon-class="item.fileName" :suffix="true" className="file"></svg-icon>
                  <a v-if="item.fileName.indexOf('.xlsx')==-1" target="_blank"
                     :title="'创建时间：' + item.ctime+' '+getFileStatusText(item.taskStatus)"
                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false">{{
                      item.fileName
                    }}</a>
                  <a v-if="item.fileName.indexOf('.xlsx')>=0" target="_blank"
                     :href="'#/excelpreview?url='+downFile+item.filePath">{{ item.fileName }}</a>
                  <a target="_blank" v-if="canDownload"
                     :href="canDownload && item.status == 30 ? downFile + item.filePath : false"
                     :download="item.fileName"><i class="el-icon-download"></i></a>
                </div>
              </td>
            </tr>
            <tr v-if="getfieldList('from_company_file')?true:false">
              <th>From Company File</th>
              <td>
                <div v-for="(item,index) in form.fromCompany" :key="index">
                  <svg-icon :icon-class="item.fileName" :suffix="true" className="file"></svg-icon>
                  <!-- <a target="_blank" :href="item.status == 30 ? '/display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false" >{{item.fileName}}</a>   -->
                  <a v-if="item.fileName.indexOf('.xlsx')==-1" target="_blank"
                     :title="'创建时间：' + item.ctime+' '+getFileStatusText(item.taskStatus)"
                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false">{{
                      item.fileName
                    }}</a>
                  <a v-if="item.fileName.indexOf('.xlsx')>=0" target="_blank"
                     :href="'#/excelpreview?url='+downFile+item.filePath">{{ item.fileName }}</a>
                  <a target="_blank" v-if="canDownload"
                     :href="canDownload && item.status == 30 ? downFile + item.filePath : false"
                     :download="item.fileName"><i class="el-icon-download"></i></a>
                </div>
              </td>
            </tr>
            <tr v-if="getfieldList('cm_research_file')?true:false">
              <th>CM Research File</th>
              <td>
                <div v-for="(item,index) in form.cmResearch" :key="index">
                  <svg-icon :icon-class="item.fileName" :suffix="true" className="file"></svg-icon>
                  <!--                  <a v-if="item.fileName.indexOf('.xlsx')==-1" target="_blank"-->
                  <!--                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false">{{-->
                  <!--                      item.fileName +''+item.ctime-->
                  <!--                    }}</a>-->
                  <a v-if="item.fileName.indexOf('.xlsx')==-1"
                     target="_blank"
                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false"
                     :title="'创建时间：' + item.ctime+' '+getFileStatusText(item.taskStatus)">
                    {{ item.fileName }}
                  </a>

                  <a v-if="item.fileName.indexOf('.xlsx')>=0" target="_blank"
                     :href="'#/excelpreview?url='+downFile+item.filePath">{{ item.fileName }}</a>
                  <a target="_blank" v-if="canDownload"
                     :href="canDownload && item.status == 30 ? downFile + item.filePath : false"
                     :download="item.fileName"><i class="el-icon-download"></i></a>
                </div>
              </td>
            </tr>
            <tr v-if="getfieldList('selection_dd_file')?true:false">
              <th>Selection DD Files</th>
              <td>
                <div v-for="(item,index) in form.selectionDDFileList" :key="index">
                  <svg-icon :icon-class="item.fileName" :suffix="true" className="file"></svg-icon>
                  <!-- <a target="_blank" :href="item.status == 30 ? '/display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false" >{{item.fileName}}</a>  -->
                  <a v-if="item.fileName.indexOf('.xlsx')==-1" target="_blank"
                     :title="'创建时间：' + item.ctime+' '+getFileStatusText(item.taskStatus)"
                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false">{{
                      item.fileName
                    }}</a>
                  <a v-if="item.fileName.indexOf('.xlsx')>=0" target="_blank"
                     :href="'#/excelpreview?url='+downFile+item.filePath">{{ item.fileName }}</a>
                  <a target="_blank" v-if="canDownload"
                     :href="canDownload && item.status == 30 ? downFile + item.filePath : false"
                     :download="item.fileName"><i class="el-icon-download"></i></a>
                </div>
              </td>
            </tr>
            <tr v-if="getfieldList('report_dd_file')?true:false">
              <th>Report DD Files</th>
              <td>
                <div v-for="(item,index) in form.reportDDFileList" :key="index">
                  <svg-icon :icon-class="item.fileName" :suffix="true" className="file"></svg-icon>
                  <!-- <a target="_blank" :href="item.status == 30 ? '/display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false" >{{item.fileName}}</a>  -->
                  <a v-if="item.fileName.indexOf('.xlsx')==-1" target="_blank"
                     :title="'创建时间：' + item.ctime+' '+getFileStatusText(item.taskStatus)"
                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false">{{
                      item.fileName
                    }}</a>
                  <a v-if="item.fileName.indexOf('.xlsx')>=0" target="_blank"
                     :href="'#/excelpreview?url='+downFile+item.filePath">{{ item.fileName }}</a>
                  <a target="_blank" v-if="canDownload"
                     :href="canDownload && item.status == 30 ? downFile + item.filePath : false"
                     :download="item.fileName"><i class="el-icon-download"></i></a>
                </div>
              </td>
            </tr>
            <tr v-if="getfieldList('legal_dd_file')?true:false">
              <th>Legal DD Files</th>
              <td>
                <div v-for="(item,index) in form.legalDDFileList" :key="index">
                  <svg-icon :icon-class="item.fileName" :suffix="true" className="file"></svg-icon>
                  <!-- <a target="_blank" :href="item.status == 30 ? '/display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false" >{{item.fileName}}</a>  -->
                  <a v-if="item.fileName.indexOf('.xlsx')==-1" target="_blank"
                     :title="'创建时间：' + item.ctime+' '+getFileStatusText(item.taskStatus)"
                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false">{{
                      item.fileName
                    }}</a>
                  <a v-if="item.fileName.indexOf('.xlsx')>=0" target="_blank"
                     :href="'#/excelpreview?url='+downFile+item.filePath">{{ item.fileName }}</a>
                  <a target="_blank" v-if="canDownload"
                     :href="canDownload && item.status == 30 ? downFile + item.filePath : false"
                     :download="item.fileName"><i class="el-icon-download"></i></a>
                </div>
              </td>
            </tr>
            <tr v-if="getfieldList('finance_dd_file')?true:false">
              <th>Finance DD Files</th>
              <td>
                <div v-for="(item,index) in form.financialDDFileList" :key="index">
                  <svg-icon :icon-class="item.fileName" :suffix="true" className="file"></svg-icon>
                  <!-- <a target="_blank" :href="item.status == 30 ? '/display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false" >{{item.fileName}}</a> -->
                  <a v-if="item.fileName.indexOf('.xlsx')==-1" target="_blank"
                     :title="'创建时间：' + item.ctime+' '+getFileStatusText(item.taskStatus)"
                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false">{{
                      item.fileName
                    }}</a>
                  <a v-if="item.fileName.indexOf('.xlsx')>=0" target="_blank"
                     :href="'#/excelpreview?url='+downFile+item.filePath">{{ item.fileName }}</a>
                  <a target="_blank" v-if="canDownload"
                     :href="canDownload && item.status == 30 ? downFile + item.filePath : false"
                     :download="item.fileName"><i class="el-icon-download"></i></a>
                </div>
              </td>
            </tr>
            <tr v-if="getfieldList('ic_report_file')?true:false">
              <th>IC Report Files</th>
              <td>
                <div v-for="(item,index) in form.icReportFileList" :key="index">
                  <svg-icon :icon-class="item.fileName" :suffix="true" className="file"></svg-icon>
                  <!-- <a target="_blank" :href="item.status == 30 ? '/display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false" >{{item.fileName}}</a>  -->
                  <a v-if="item.fileName.indexOf('.xlsx')==-1" target="_blank"
                     :title="'创建时间：' + item.ctime+' '+getFileStatusText(item.taskStatus)"
                     :href="item.status == 30 ? 'display.html' + '?id=' + item.id + '&n=' + item.viewPageNum : false">{{
                      item.fileName
                    }}</a>
                  <a v-if="item.fileName.indexOf('.xlsx')>=0" target="_blank"
                     :href="'#/excelpreview?url='+downFile+item.filePath">{{ item.fileName }}</a>
                  <a target="_blank" v-if="canDownload"
                     :href="canDownload && item.status == 30 ? downFile + item.filePath : false"
                     :download="item.fileName"><i class="el-icon-download"></i></a>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="demo-drawer__footer">
        <!-- <el-button type="primary">确 定</el-button> -->
      </div>
    </el-dialog>
  </div>

</template>

<script>
import panel from "../components/layout/panel";
import {
  getDocumentListApi,
  getDictDataInfoApi,
  getDictDataListApi,
  getDocumentInfoApi,
  downFile,
  getElasticSearchResultsApi
} from "../service/api.js";
import {dateFormat, farmatDate} from "../common/utils"
import {addAppreciateDocumentBehaviorApi} from "../service/behavior.js"
import {countrys} from "../common/country";

export default {
  components: {
    "imp-panel": panel
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: 'Latest week',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last month',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: 'Last 3 months',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        },
          {
            text: 'Last 6 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: 'Recent year',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
              picker.$emit('pick', [start, end]);
            }
          },
        ]
      },
      countryList: countrys,
      areaList: [],
      // prefixFile:"cm-deals",
      cmResearchList: [],
      customTime: [],
      canDownload: false,
      canEdit: false,
      canCreate: false,
      roles: window.localStorage.getItem('roles') || [],
      downFile: downFile,
      dialog: false,
      dialogTableVisible: false,
      statusStr: '',
      statusList: [],
      typeList: [],
      sectorList: [],
      productStageList: [],
      sourceList: [],
      dealTeamList: [],
      fieldItems: [],
      tableData: {
        pagination: {
          total: 0,
          pageNo: 1,
          pageSize: 15,
          totalSize: 0
        },
        rows: []
      },
      search: {
        name: "",
        keywords: ""
      },
      form: {
        entryDate: "",
        updateDate: "",
        followUpDate: "",
        name: "",
        otherName: "",
        website: "",
        type: 10,
        country: [],
        sector: "",
        productStage: "",
        keywords: [],
        companyDescription: "",
        technologyProduct: "",
        market: "",
        competition: "",
        bizModel: "",
        team: "",
        financials: "",
        status: "",
        cmComments: "",
        nda: "",
        contactPersonList: [],
        ndaFileList: [],
        nonConfidentialPresentation: [],
        source: "",
        refferedBy: "",
        sourcedBy: "",
        dealTeam: "",
        innerTechnologyProduct: "",
        customerTraction: "",
        innerCMcomments: "",
        activityInfoList: "",
        fromCompany: [],
        enterIntoDd: "",
        termSheet: "",
        termSheetComments: "",
        termSheetFileList: [],
        cmResearch: [],
        legalDDFileList: [],
        financialDDFileList: [],
        fileList: [],
        stage: "",
        revenue: "",
        capitalRaise: "",
        mtime: "",
        selectionDDFileList: [],
        reportDDFileList: [],
        icReportFileList: [],
        cmResearchVal: "",
      },
      searchedFields: [],
      // flag
      stageList: [],
      revenueList: [],
      fullText: "",
      rules5: false,
      path: "/fullTextSearch",
      isPartnerRule: false,
      excludeStatus: "",
      isNotPartnerRule: false,
    }
  },
  created() {
    this.getDictDataList(2)
    this.getDictDataList(3)
    this.getDictDataList(4)
    this.getDictDataList(5)
    this.getDictDataList(6)
    this.getDictDataList(7)
    this.getDictDataList(10)
    this.getDictDataList(11)
    this.getDictDataList(12)
    this.getRoles()
    this.getAreaList()
    // console.log('downfile ',this.downFile);
  },
  mounted() {
    this.getDocumentList();
    // this.searchEvent()
  },
  computed: {},
  methods: {
    getFileStatusText(status) {
      let text = '-'
      switch (status) {
        case 0:
          text = '新建'
          break
        case 1:
          text = '等待处理'
          break
        case 2:
          text = '处理中'
          break
        case 3:
          text = '成功'
          break
        case 4:
          text = '失败'
          break
        default:
          text = '已取消'
          break
      }
      return text
    },
    getAreaList() {
      this.areaList = [];
      for (let i = 0; i < this.countryList.length; i++) {
        this.areaList.push(this.countryList[i])
      }
    },
    // Excel文件在线预览
    excelPrview(fileUrl) {
      this.$router.push({name: '/excelpreview', params: {'fileUrl': fileUrl}});
    },
    // 获取时间区间
    timeInterval(type) {
      const end = new Date();
      const start = new Date();

      switch (type) {
        case "0":
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          break;
        case "1":
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          break;
        case "2":
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          break;
        case "3":
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
          break;
        case "4":
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
          break;
      }
      // 格式化 yyyy-MM-dd
      return [dateFormat("YYYY-mm-dd", start), dateFormat("YYYY-mm-dd", end)]
    },
    // 格式化时间
    formatMtime(time) {
      return farmatDate(time);
    },
    // 权限控制
    getRoles() {

      const roles = window.localStorage.getItem('roles') || [];
      const updFlag = window.localStorage.getItem('updFlag') || 0;

      // [创建]与[编辑]  角色ID：2，或3，或4；
      if (roles.indexOf(2) > -1
        || roles.indexOf(3) > -1
        || roles.indexOf(4) > -1
        && updFlag == 1) {
        this.canCreate = true;
        this.canEdit = true;
      }
      // [下载] 角色ID：2，或3；
      if (roles.indexOf(2) > -1) {
        this.canDownload = true;
      }
      // [限定特定时间之后] 角色ID：4，或5；
      if (roles.indexOf(4) > -1 || roles.indexOf(5) > -1) {
        this.bindTime = true;
      }
      // LP(角色rolus = 5) 不能看到 readonly 字典值信息, 60 readonly
      // if (roles.indexOf(5) > -1) {
      //   this.rules5 = true
      //   this.excludeStatus += "60,"
      // }

      // TODO ====================================》
      // Partner(角色rule = 2) ：角色可以查看 status = LP/CVC/Investor = 80
      // if (roles.indexOf(2) === -1) {
      //   this.excludeStatus += "80,"
      // }
      // VP : 可以看 Status为LP/CVC/Investor 和 portfolio company， Selected for DD的项目
      // VP : 不可以看 Status 为 New deal, initial analysis, passed, revisit, research only 的项目
      if (roles.indexOf(3) >= 0) {
        this.excludeStatus += "10,20,40,50,60," //排除
      }
      // Associate/Analyst: 可以看 status为New Dea, initial analysis, selected for DD, passed, revisit, research only, portfolio 的项目
      // Associate/Analyst: 不可以看 Status 为 LP/CVC/Investor的项目

      // if (roles.indexOf(4) >= 0 || roles.indexOf(2) === -1) {
      if (roles.indexOf(4) >= 0) {
        this.excludeStatus += "80,"
      }

      // LP: 可以看 status为New Dea, initial analysis, selected for DD, passed, revisit, portfolio 的项目
      // LP: 不可以看 Status 为 Research only, LP/CVC/Investor的项目
      if (roles.indexOf(5) >= 0) {
        this.excludeStatus += "60,80,"//排除
      }
      if (this.excludeStatus.length > 0) {
        this.excludeStatus = this.excludeStatus.substring(0, this.excludeStatus.length - 1)
      }
      console.log('getrole excludeStatus', roles, this.excludeStatus)
    },
    handleSizeChange(val) {
      this.tableData.pagination.pageSize = val;
      // this.getDocumentList();
      if (this.fullText.length == 0) {
        this.searchEvent()
        return
      }
      this.getFullTextSearchResults();
    },
    handleCurrentChange(val) {
      this.tableData.pagination.pageNo = val;
      // this.getDocumentList();
      if (this.fullText.length == 0) {
        this.searchEvent()
        return
      }
      this.getFullTextSearchResults();
    },
    editPage(documentId) {
      this.$router.push({path: '/edit', query: {documentId: documentId}});
    },
    createPage() {
      this.$router.push({path: '/add'});
    },
    searchEvent() {
      // const roles = window.localStorage.getItem('roles') || [];
      // let excludeStatus = ""
      // // TODO ====================================》
      // // Partner(角色rule = 2) ：角色可以查看 status = LP/CVC/Investor = 80
      // // if (roles.indexOf(2) >= 0) {
      // // excludeStatus += "80,"
      // // }
      // // VP : 可以看 Status为LP/CVC/Investor 和 portfolio company， Selected for DD的项目
      // // VP : 不可以看 Status 为 New deal, initial analysis, passed, revisit, research only 的项目
      // if (roles.indexOf(3) >= 0) {
      //   excludeStatus += "10,20,40,50,60," //排除
      // }
      // // Associate/Analyst: 可以看 status为New Dea, initial analysis, selected for DD, passed, revisit, research only, portfolio 的项目
      // // Associate/Analyst: 不可以看 Status 为 LP/CVC/Investor的项目
      // if (roles.indexOf(4) >= 0) {
      //   excludeStatus += "80,"//排除
      // }
      // // LP: 可以看 status为New Dea, initial analysis, selected for DD, passed, revisit, portfolio 的项目
      // // LP: 不可以看 Status 为 Research only, LP/CVC/Investor的项目
      // if (roles.indexOf(5) >= 0) {
      //   excludeStatus += "60,80,"//排除
      // }
      // if (excludeStatus.length > 0) {
      //   excludeStatus = excludeStatus.substring(0, excludeStatus.length - 1)
      // }
      //
      // let statuss = new Set(excludeStatus.split(","));
      // if (statuss.size > 0) {
      //   for (let value of statuss) {
      //     if (value && value.length > 0) {
      //       this.searchedFields.push(
      //         {name: 'status', type: 2, value: value, criteria: 6, order: 0}
      //       )
      //     }
      //   }
      // } else {
      //   this.searchedFields = []
      // }
      this.getDocumentList()
    },
    //获取文档列表
    getDocumentList() {
      if (this.search.status) {
        this.searchedFields.push(
          {name: 'status', type: 2, value: this.search.status, criteria: 1, order: 0}
        )
      }
      if (this.search.sector) {
        this.searchedFields.push({
          name: 'sector', type: 2, value: this.search.sector, criteria: 1, order: 0
        })
      }
      if (this.search.area) {
        this.searchedFields.push({
          name: 'country', type: 1, value: this.search.area, criteria: 7, order: 0
        })
      }
      if (this.search.name) {
        this.searchedFields.push(
          {name: 'name', type: 1, value: this.search.name, criteria: 7, order: 0},
          {name: 'otherName', type: 1, value: this.search.name, criteria: 7, order: 0}
        )
      }
      if (this.search.stage) {
        this.searchedFields.push({
          name: 'stage', type: 2, value: this.search.stage, criteria: 1, order: 0
        })
      }
      if (this.search.revenue) {
        this.searchedFields.push({
          name: 'revenue', type: 2, value: this.search.revenue, criteria: 1, order: 0
        })
      }

      // if (this.$route.query.status) {
      //   this.searchedFields.push(
      //     {name: 'status', type: 2, value: this.$route.query.status, criteria: 1, order: 0}
      //   )
      // }
      // if (this.$route.query.sector) {
      //   this.searchedFields.push({
      //     name: 'sector', type: 2, value: this.$route.query.sector, criteria: 1, order: 0
      //   })
      // }
      // if (this.$route.query.country) {
      //   this.searchedFields.push({
      //     name: 'country', type: 1, value: this.$route.query.country, criteria: 7, order: 0
      //   })
      // }
      // 处理dataEntry
      let formBeginTime = ""
      let formEndTime = ""
      // if (this.$route.query.dataEntry && this.$route.query.dataEntry.length > 0) {
      //   // 0  last week
      //   // 1  last month
      //   // 2  last 3 months
      //   // 3  last 6 months
      //   // 4  recent year
      //   let arr = this.timeInterval(this.$route.query.dataEntry)
      //   if (arr && arr.length == 2) {
      //     // 开始时间
      //     formBeginTime = arr[0]
      //     // 结束时间
      //     formEndTime = arr[1]
      //   }
      // }
      if (this.customTime && this.customTime.length > 0) {
        formBeginTime = this.customTime[0] ? this.customTime[0] : ""
        formEndTime = this.customTime[1] ? this.customTime[1] : ""
      }

      // 先判断当前角色是否限制日期
      if (this.bindTime) {
        // 做判断 格式: yyyy-MM-dd
        let userBeginTime = window.localStorage.getItem("startTime") || ""
        let userEndTime = window.localStorage.getItem("endTime") || ""
        // 根据表单选择日期和用户设置日期判断，表单选择日期开始结束不能大于用户设置日期
        if (this.customTime && this.customTime.length > 0) {
          // 开始时间 格式: yyyy-MM-dd
          if (userBeginTime && userBeginTime.length > 0 && userEndTime && userEndTime.length > 0) {
            // 相减和小于0，选择日期大于用户设置日期。不能查询。默认查询用户设置日期
            if (Date.parse(userBeginTime) - Date.parse(formBeginTime) >= 0) {
              formBeginTime = userBeginTime
            }
            if (Date.parse(userEndTime) - Date.parse(formEndTime) <= 0) {
              formEndTime = userEndTime
            }
          }
        } else {
          formBeginTime = userBeginTime
          formEndTime = userEndTime
        }
      }
      if (formBeginTime && formEndTime) {
        this.searchedFields.push({
          name: 'ctime', type: 4, value: formBeginTime, criteria: 2, order: 0, format: "yyyy-MM-dd"
        })
        this.searchedFields.push({
          name: 'ctime', type: 4, value: formEndTime, criteria: 4, order: 0, format: "yyyy-MM-dd"
        })
      }

      // else{
      //   if (formBeginTime && formEndTime) {
      //     this.searchedFields.push({
      //       name: 'entryDate', type: 4, value: formBeginTime, criteria: 2, order: 0, format: "yyyy-MM-dd"
      //     })
      //     this.searchedFields.push({
      //       name: 'entryDate', type: 4, value: formEndTime, criteria: 4, order: 0, format: "yyyy-MM-dd"
      //     })
      //   }
      // }

      // flag
      // if (this.$route.query.stage) {
      //   this.searchedFields.push(
      //     {name: 'stage', type: 2, value: this.$route.query.stage, criteria: 1, order: 0}
      //   )
      // }
      // // flag
      // if (this.$route.query.revenue) {
      //   this.searchedFields.push(
      //     {name: 'revenue', type: 2, value: this.$route.query.revenue, criteria: 1, order: 0}
      //   )
      // }
      /*
      status
      {itemId: 10, itemName: "New deal", orderNum: 10, description: "New deal"}
      {itemId: 20, itemName: "Initial analysis", orderNum: 20, description: "Initial analysis"}
      {itemId: 30, itemName: "Selected for DD", orderNum: 30, description: "Selected for DD"}
      {itemId: 40, itemName: "Passed", orderNum: 40, description: "Passed"}
      {itemId: 50, itemName: "Revisit", orderNum: 50, description: "Revisit"}
      {itemId: 60, itemName: "Research only", orderNum: 60, description: "Research only"}
      {itemId: 70, itemName: "Portfolio company", orderNum: 70, description: "Portfolio company"}
      {itemId: 80, itemName: "LP/CVC/Investor", orderNum: 80, description: "LP/CVC/Investor"}
      */
      // 不是Partner角色不可查看status=80的
      // if (this.isNotPartnerRule) {
      //   this.searchedFields.push(
      //     {name: 'status', type: 2, value: "80", criteria: 6, order: 0}
      //   )
      // }
      //
      console.log('before getDocumentList ', this.excludeStatus)
      console.log('before getDocumentList', this.searchedFields)

      // 25.12.16
      if (this.excludeStatus.length > 0) {
        let statuss = new Set(this.excludeStatus.split(","));
        console.log('statuss', statuss)
        if (statuss.size > 0) {
          for (let value of statuss) {
            this.searchedFields.push(
              {name: 'status', type: 2, value: value, criteria: 6, order: 0}
            )
          }
        }
      }

      getDocumentListApi({
        userId: window.localStorage.getItem("userId"),
        keywords: this.search.keywords,
        pageNum: this.tableData.pagination.pageNo,
        pageSize: this.tableData.pagination.pageSize,
        searchedFields: this.searchedFields
      }).then(res => {
        if (res && res.code == 0) {
          this.searchedFields = []
          this.tableData.pagination.totalSize = 0
          if (res.items.length > 0) {
            this.tableData.pagination.totalSize = res.totalSize;
          }
          this.tableData.rows = res.items || [];
          // console.log('-------------> this.tableData', this.tableData)
        } else {
          this.searchedFields = []
          this.tableData.rows = []
          this.tableData.pagination.totalSize = 0;
          // this.$message.error("error code:" + res.code + ";" + res.message);
        }
      })
    },
    getDocumentInfo(documentId) {
      getDocumentInfoApi({
        userId: window.localStorage.getItem('userId'),
        documentId: documentId
      }).then(res => {
        if (res && res.code == 0) {
          this.dialogTableVisible = true
          this.form.documentId = documentId
          this.form.entryDate = res.entryDate
          this.form.updateDate = res.updateDate
          this.form.followUpDate = res.followUpDate
          this.form.name = res.name
          this.form.otherName = res.otherName
          this.form.website = res.website
          this.form.type = this.getObjectValues(this.typeList, res.type)
          this.form.country = res.country
          this.form.sector = this.getObjectValues(this.sectorList, res.sector)
          this.form.productStage = this.getObjectValues(this.productStageList, res.productStage)
          this.form.cmResearchVal = this.getObjectValues(this.cmResearchList, res.cmResearch)
          this.form.companyDescription = res.companyDescription
          this.form.technologyProduct = res.technologyProduct
          this.form.market = res.market
          this.form.competition = res.competition
          this.form.bizModel = res.bizModel
          this.form.team = res.team
          this.form.financials = res.financials
          this.form.status = this.getObjectValues(this.statusList, res.status)
          // flag
          this.form.stage = this.getObjectValues(this.stageList, res.stage)
          this.form.revenue = this.getObjectValues(this.revenueList, res.revenue)
          this.form.capitalRaise = res.capitalRaise
          // mtime
          this.form.mtime = res.mtime

          this.form.cmComments = res.cmComments
          this.form.nda = res.nda
          this.form.keywords = []
          if (res.keywords && res.keywords.length > 0) {
            for (let i = 0; i < res.keywords.length; i++) {
              this.form.keywords += res.keywords[i].keyword + ","
            }
            if (this.form.keywords.length > 0) {
              this.form.keywords = this.form.keywords.substr(0, this.form.keywords.length - 1);
            }
          }
          this.form.contactPersonList = res.contactPersonList
          this.form.source = this.getObjectValues(this.sourceList, res.source)
          this.form.refferedBy = res.refferedBy
          this.form.sourcedBy = res.sourcedBy
          this.form.dealTeam = this.getObjectValues(this.dealTeamList, res.dealTeam)
          this.form.innerTechnologyProduct = res.innerTechnologyProduct
          this.form.customerTraction = res.customerTraction
          this.form.innerCMcomments = res.innerCMcomments
          this.form.enterIntoDd = res.enterIntoDd
          this.form.termSheet = res.termSheet
          this.form.termSheetComments = res.termSheetComments
          this.form.activityInfoList = res.activityInfoList
          this.form.ndaFileList = [];
          this.form.nonConfidentialPresentation = [];
          this.form.fromCompany = [];
          this.form.cmResearch = [];
          this.form.termSheetFileList = [];
          this.form.legalDDFileList = [];
          this.form.financialDDFileList = [];
          this.form.selectionDDFileList = [];
          this.form.reportDDFileList = [];
          this.form.icReportFileList = [];
          if (res.fileList && res.fileList.length > 0) {
            for (let i = 0; i < res.fileList.length; i++) {
              if (res.fileList[i].fileType == "nda_file") {
                this.form.ndaFileList.push(res.fileList[i])
              } else if (res.fileList[i].fileType == "non_confidential_presentation_file") {
                this.form.nonConfidentialPresentation.push(res.fileList[i])
              } else if (res.fileList[i].fileType == "from_company_file") {
                this.form.fromCompany.push(res.fileList[i])
              } else if (res.fileList[i].fileType == "cm_research_file") {
                this.form.cmResearch.push(res.fileList[i])
              } else if (res.fileList[i].fileType == "term_sheet_file") {
                this.form.termSheetFileList.push(res.fileList[i])
              } else if (res.fileList[i].fileType == "legal_dd_file") {
                this.form.legalDDFileList.push(res.fileList[i])
              } else if (res.fileList[i].fileType == "finance_dd_file") {
                this.form.financialDDFileList.push(res.fileList[i])
              } else if (res.fileList[i].fileType == "selection_dd_file") {
                this.form.selectionDDFileList.push(res.fileList[i])
              } else if (res.fileList[i].fileType == "report_dd_file") {
                this.form.reportDDFileList.push(res.fileList[i])
              } else if (res.fileList[i].fileType == "ic_report_file") {
                this.form.icReportFileList.push(res.fileList[i])
              }
            }
          }
          // 埋点：用户阅读行为
          addAppreciateDocumentBehaviorApi({
            userId: parseInt(window.localStorage.getItem('userId') || ""),
            documentId: documentId
          }).then(res => {
            if (res && res.code == 200) {
              console.log("已记录")
            } else {
              console.log("记录失败")
            }
          }).catch(err => {
            console.log("记录失败:", err)
          })
        } else {
          // this.$message.error("code:" + res.code + ',' + res.message);
        }
      })
    },
    getDictDataList(groupId) {
      getDictDataListApi({
        userId: window.localStorage.getItem('userId'),
        groupId: groupId
      }).then(res => {
        if (res && res.code == 0) {
          if (groupId == 2) {
            this.typeList = res.items
          } else if (groupId == 3) {
            this.sectorList = res.items
          } else if (groupId == 4) {
            this.productStageList = res.items
          } else if (groupId == 5) {
            //this.statusList = res.items
            let statusList = res.items
            // console.log('this.statusList    ', this.statusList)
            // console.log('localStorage   ', localStorage.getItem('roles'))

            let userRoles = localStorage.getItem('roles')

            // TODO 非IR(3)非Partner(2) Status 下拉框不显示 LP/CVC
            let LPCVC = 'LP/CVC/Investor'
            let isDelLPCVC = false
            if (userRoles && userRoles.length > 0) {
              if (userRoles != 2 && userRoles != 3) {
                isDelLPCVC = true
              }
            }
            if (isDelLPCVC) {
              for (let i = 0; i < statusList.length; i++) {
                // console.log(statusList[i].itemName)
                if (statusList[i].itemName.indexOf(LPCVC) !== -1) {
                  statusList.splice(i, 1)
                }
              }
            }
            console.log('handled  ', statusList)
            this.statusList = statusList

          } else if (groupId == 6) {
            this.sourceList = res.items
          } else if (groupId == 7) {
            this.dealTeamList = res.items
          } else if (groupId == 10) {
            this.stageList = res.items || [];
          } else if (groupId == 11) {
            this.revenueList = res.items || [];
          } else if (groupId == 12) {
            this.cmResearchList = res.items || [];
          }
        } else {
          // this.$message.error("code:" + res.code + "," + res.message);
        }
      })
    },
    getDictDataInfo(groupId, itemId) {
      getDictDataInfoApi({
        userId: window.localStorage.getItem('userId'),
        groupId: groupId,
        itemId: itemId
      }).then(res => {
        if (res && res.code == 0) {
          return res.itemName
        } else {
          // this.$message.error("code:" + res.data.code + "," + res.data.message)
        }
      })
    },
    getObjectValues(object, id) {
      for (var property in object) {
        if (object[property].itemId == id) {
          return object[property].itemName
        }
      }
      return "";
    },
    getfieldList(fieLdName) {
      if (window.localStorage.getItem("fieldItems")) {
        var fieldItems = JSON.parse(window.localStorage.getItem("fieldItems"))
        for (let i = 0; i < fieldItems.length; i++) {
          if (fieldItems[i].fieldName == fieLdName) {
            return true;
          }
        }
        return false
      } else {
        return false
      }
    },
    change() {
      this.tableData.pagination.pageNo = 1;
      console.log(this.fullText)
      if (this.fullText.length == 0) {
        this.searchEvent() // 普通查询
      } else {
        // ES全文检索查询
        this.getFullTextSearchResults();
      }
    },
    // 根据role 排除 status
    getExcludeStatusFunc() {
      // const roles = window.localStorage.getItem('roles') || [];
      // let excludeStatus = ""
      // // TODO ====================================》
      // // Partner(角色rule = 2) ：角色可以查看 status = LP/CVC/Investor = 80
      // // if (roles.indexOf(2) === -1) {
      // //   excludeStatus += "80,"
      // // }
      // // VP : 可以看 Status为LP/CVC/Investor 和 portfolio company， Selected for DD的项目
      // // VP : 不可以看 Status 为 New deal, initial analysis, passed, revisit, research only 的项目
      // if (roles.indexOf(3) >= 0) {
      //   excludeStatus += "10,20,40,50,60," //排除
      // }
      // // Associate/Analyst: 可以看 status为New Dea, initial analysis, selected for DD, passed, revisit, research only, portfolio 的项目
      // // Associate/Analyst: 不可以看 Status 为 LP/CVC/Investor的项目
      // if (roles.indexOf(4) >= 0) {
      //   excludeStatus += "80,"//排除
      // }
      // // LP: 可以看 status为New Dea, initial analysis, selected for DD, passed, revisit, portfolio 的项目
      // // LP: 不可以看 Status 为 Research only, LP/CVC/Investor的项目
      // if (roles.indexOf(5) >= 0) {
      //   excludeStatus += "60,80,"//排除
      // }
      // if (excludeStatus.length > 0) {
      //   excludeStatus = excludeStatus.substring(0, excludeStatus.length - 1)
      // }
      // return excludeStatus
      return ""
    },
    // ES全文检索API
    getFullTextSearchResults() {
      let formBeginTime = ""
      let formEndTime = ""
      if (this.$route.query.dataEntry && this.$route.query.dataEntry.length > 0) {
        // 0  last week
        // 1  last month
        // 2  last 3 months
        // 3  last 6 months
        // 4  recent year
        let arr = this.timeInterval(this.$route.query.dataEntry)
        if (arr && arr.length == 2) {
          // 开始时间
          formBeginTime = arr[0]
          // 结束时间
          formEndTime = arr[1]
        }
      }
      if (this.customTime && this.customTime.length > 0) {
        formBeginTime = this.customTime[0] ? this.customTime[0] : ""
        formEndTime = this.customTime[1] ? this.customTime[1] : ""
      }

      // 先判断当前角色是否限制日期
      if (this.bindTime) {
        // 做判断 格式: yyyy-MM-dd
        let userBeginTime = window.localStorage.getItem("startTime") || ""
        let userEndTime = window.localStorage.getItem("endTime") || ""
        // 根据表单选择日期和用户设置日期判断，表单选择日期开始结束不能大于用户设置日期
        if (this.customTime && this.customTime.length > 0) {
          // 开始时间 格式: yyyy-MM-dd
          if (userBeginTime && userBeginTime.length > 0 && userEndTime && userEndTime.length > 0) {
            // 相减和小于0，选择日期大于用户设置日期。不能查询。默认查询用户设置日期
            if (Date.parse(userBeginTime) - Date.parse(formBeginTime) >= 0) {
              formBeginTime = userBeginTime
            }
            if (Date.parse(userEndTime) - Date.parse(formEndTime) <= 0) {
              formEndTime = userEndTime
            }
          }
        } else {
          formBeginTime = userBeginTime
          formEndTime = userEndTime
        }
      }
      console.log("es", this.excludeStatus)

      // let exStatus = this.getExcludeStatusFunc()
      let exStatus = ''
      let tempSet = this.excludeStatus.split(",").concat(exStatus.split(","))
      console.log('===========> tempSet', tempSet);
      var set = new Set(tempSet.filter(Boolean));
      let statuss = ""
      if (set.size > 0) {
        statuss = Array.from(set).toString()
      }

      getElasticSearchResultsApi({
        userId: window.localStorage.getItem("userId"),
        pageNum: this.tableData.pagination.pageNo,
        limit: this.tableData.pagination.pageSize,
        search: this.fullText,
        startTime: formBeginTime,
        endTime: formEndTime,
        // 默认角色排除项
        roleExcludeStatus: statuss || "",
        status: this.search.status || 0,
        area: this.search.area,
        stage: this.search.stage || 0,
        sector: this.search.sector || 0,
        revenue: this.search.revenue || 0,
        name: this.search.name,
        otherName: this.search.name,
        keywords: this.search.keywords
      }).then(res => {
        if (res && res.code == 200) {
          this.tableData.pagination.totalSize = res.totalCount;
          this.tableData.rows = res.content;
        } else if (res.code == 500) {
          // this.$message.success("There is no data matching this sentence.");
          this.tableData.pagination.totalSize = 0
          this.tableData.rows = []
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-drawer__header {
  border-bottom: 1px solid #ededee;
  padding-bottom: 15px;
  margin-top: 10px;
}

.search__wapper {
  padding: 10px 0;
}

.search__item {
  font-size: 16px;
  padding: 5px 0px;
}

.el-checkbox__label {
  font-size: 16px;
}

.el-row {
  margin-bottom: 20px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 0px;
  margin-bottom: 20px;
}

.bg-purple-dark {
  background: #ffffff;
}

.bg-purple {
  background: #d3dce6;
}

.bg-purple-light {
  background: #e5e9f2;
}

.grid-content {
  padding: 10px;
  line-height: 25px;
  border-radius: 0px;
  min-height: 36px;
  height: 250px;
}

.row-bg {
  padding: 10px 0;
  background-color: #fff;
}

.nav-btn {
  margin: 10px 0;
  text-align: right;
}

@media only screen and (min-width: 1920px) {
  .el-col-xl-5 {
    width: 20%;
  }
}

@media only screen and (min-width: 1200px) {
  .el-col-xl-5 {
    width: 20%;
  }
}

.info-wapper {
  padding: 10px;
}

.table-custom {
  width: 100%;
  border: 1px solid #ededee;
  font-size: 16px;
  text-align: left;

  tr {
    th {
      width: 200px;
      padding: 5px 10px;
      border: 1px solid #ededee;
      background: #f9fafa;
    }

    td {
      padding: 5px 10px;
      border: 1px solid #ededee;
      word-break: keep-all;
    }
  }
}

.box-crad__header {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  height: 22px;
}

.box-card__footer {
  text-align: left;
}

.demo-form-inline {
  background: #fff;
  padding: 15px;
  margin-bottom: 10px;
}

.box-card_text {
  overflow: hidden;
  white-space: nowrap;
  text-align: center;
  text-overflow: ellipsis;
}

.box-card__footer_text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/list.vue